module.exports = __webpack_public_path__ + "img/2.52f3c369.jpg";